import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class BargainingService {
  public list: any = [];

  public baseUrl: string = "/bargaining";

  constructor(private _httpClient: HttpClient) {}

  async getBargainings() {
    return this._httpClient
      .get(this.baseUrl)
      .toPromise()
      .then((response) => {
        this.list = response;
        return response;
      });
  }

  async getBargaining(id: number) {
    return this._httpClient.get(this.baseUrl + "/" + id).toPromise();
  }

  async checkIfUserHasBargaining(user_hash: string) {
    return this._httpClient.get(`/bargaining/user/${user_hash}`).toPromise();
  }

  // create
  async createBragaining(data: any = {}) {
    return this._httpClient.post(this.baseUrl, data).toPromise();
  }

  // update
  async updateBargaining(id: number, data: any = {}) {
    return this._httpClient.put(this.baseUrl + "/" + id, data).toPromise();
  }

  async updateBargainingStatus(id: number, data: any) {
    return this._httpClient.put("/bargaining-status/" + id, data).toPromise();
  }

  // delete
  async deleteBargaining(id: number) {
    return this._httpClient
      .delete(this.baseUrl + "/" + id)
      .toPromise()
      .catch((error) => {
        console.error(error);
        return error;
      });
  }

  //Gestione iter documenti
  async updateDocumentStatus(id: number, data: any = {}) {
    return this._httpClient.put("/bargaining-attachment/" + id, data).toPromise();
  }
}
